module.exports = __webpack_public_path__ + "static/media/background2.dfdb65d1.gif";